<div class="border-secondary-base inline-flex flex-col space-y-4">
  <div class="flex w-full">
    <div class="mr-auto flex items-center w-full justify-between">
      <ng-icon
        name="featherChevronLeft"
        (click)="previous()"
        class="cursor-pointer"
      ></ng-icon>
      <div class="flex gap-4">
        <div
          class="border rounded-[8px] w-[120px] px-2 py-1 flex items-center justify-center"
          #monthRef
          role="combobox"
          (focus)="openMonth()"
          [attr.aria-expanded]="opened"
          #trigger1="cdkOverlayOrigin"
          cdkOverlayOrigin
          (click)="openMonth()"
        >
          {{ months[month] }}
          <ng-icon name="featherChevronDown"></ng-icon>
        </div>

        <div
          class="border rounded-[8px] px-2 py-1 flex items-center"
          #yearRef
          role="combobox"
          (focus)="openYear()"
          [attr.aria-expanded]="opened"
          #trigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          (click)="openYear()"
        >
          {{ year }}
          <ng-icon name="featherChevronDown"></ng-icon>
        </div>
      </div>
      <ng-icon
        name="featherChevronRight"
        (click)="next()"
        class="cursor-pointer"
      ></ng-icon>
    </div>
  </div>

  <table class="w-full border-collapse space-y-1" #daysTable>
    <thead>
      <tr class="flex">
        @for (day of days; track day; let index = $index) {
        <th
          scope="col"
          [attr.aria-label]="days[index]"
          class="text-muted-base dark:text-dark-muted flex-1 text-center text-xs font-medium"
        >
          {{ day | slice : 0 : 2 }}
        </th>
        }
      </tr>
    </thead>
    <tbody role="rowgroup">
      @for (week of calendarDays.keys(); track week) {
      <tr class="mt-2 flex w-full">
        @for (day of calendarDays.get(week); track day.day; let index = $index)
        { @if (day.month === month) {
        <td
          class="flex-1 text-center text-xs"
          [ngClass]="{
            'bg-teal-99': showPeriod(day)
          }"
        >
          <button
            type="button"
            class="font-normal hover:bg-secondary-active focus:bg-secondary-active w-6 h-6 rounded-full p-1 transition-all duration-300 ease-in-out"
            [ngClass]="{
                'bg-teal-seed text-white': activeDate(day),
                'text-gray-seed': disabledButton(day),
                'bg-white': day.month !== month,
              }"
            (click)="selectDay(day)"
            [disabled]="disabledButton(day)"
          >
            {{ day.day }}
          </button>
        </td>
        }@else {
        <td class="flex-1 text-center text-xs"></td>
        } }
      </tr>
      }
    </tbody>
  </table>
</div>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="close()"
  (backdropClick)="close()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="opened"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: hasBottomSpace ? 'bottom' : 'top',
      overlayX: 'start',
      overlayY: hasBottomSpace ? 'top' : 'bottom',
      offsetX: 0,
      offsetY: hasBottomSpace ? 3 : -3
    }
  ]"
>
  <div
    class="grid grid-cols-1 w-[106px] gap-2 px-4 py-2 bg-white shadow-detail rounded-[12px] h-[250px] overflow-scroll hide-scrollbar"
  >
    @for (yearV of years; track $index) {
    <div
      class="flex justify-center items-center rounded-[4px] cursor-pointer col-span-1"
      [ngClass]="{ 'bg-teal-seed text-white': yearV === year }"
      (click)="selectYear(yearV)"
    >
      {{ yearV }}
    </div>
    }
  </div>
</ng-template>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="close()"
  (backdropClick)="close()"
  [cdkConnectedOverlayOrigin]="trigger1"
  [cdkConnectedOverlayOpen]="openedMonth"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: hasBottomSpace ? 'bottom' : 'top',
      overlayX: 'start',
      overlayY: hasBottomSpace ? 'top' : 'bottom',
      offsetX: 0,
      offsetY: hasBottomSpace ? 3 : -3
    }
  ]"
>
  <div
    class="grid grid-cols-1 w-full gap-2 px-4 py-2 bg-white shadow-detail rounded-[12px] h-[250px] overflow-scroll hide-scrollbar"
  >
    @for (mont of months; track $index) {
    <div
      class="flex justify-center items-center rounded-[4px] cursor-pointer col-span-1"
      [ngClass]="{ 'bg-teal-seed text-white': month === $index }"
      (click)="selectMonth($index)"
    >
      {{ mont }}
    </div>
    }
  </div>
</ng-template>
